import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featuredContent } from '@/mocks/home';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function FeaturedSection() {
  const { t } = useTranslation();
  const revealRef = useScrollReveal();

  return (
    <section ref={revealRef} className="reveal max-w-[1200px] mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          {t('section.featured')}
        </h2>
        <Link
          to="/category/movies"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors"
        >
          {t('view_all')}
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {featuredContent.map((item) => (
          <Link
            key={item.id}
            to={`/article/${item.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute top-2 left-2">
                <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                  {item.rating}
                </span>
              </div>
              <div className="absolute bottom-3 left-3 right-3">
                <span className="text-white/80 text-xs">{item.category}</span>
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
              {item.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
              {item.description}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}